import React from 'react';
import ReactDOM from 'react-dom';


const appRoot = document.getElementById('root');
const modalRoot = document.getElementById('modal-root');
class Modal extends React.Component {
    constructor(props) {
        super(props);
        this.el = document.createElement('div');
        this.el.classList.add('customize-popup');
    }

    componentDidMount() {
        // The portal element is inserted in the DOM tree after
        // the Modal's children are mounted, meaning that children
        // will be mounted on a detached DOM node. If a child
        // component requires to be attached to the DOM tree
        // immediately when mounted, for example to measure a
        // DOM node, or uses 'autoFocus' in a descendant, add
        // state to Modal and only render the children when Modal
        // is inserted in the DOM tree.
        modalRoot.appendChild(this.el);
        //appRoot.style.opacity = 0;

    }

    componentWillUnmount() {
        modalRoot.removeChild(this.el);
        //appRoot.style.opacity = 1;
    }

    render() {

        return ReactDOM.createPortal(
            this.props.children,
            this.el
        );
    }
}



export default Modal;